import React from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd';
import FundamentosLegalesItems from './FundamentosLegalesItems';

const FundamentosLegalesTab = ({ plantilla }) => {
  const fundamentosLegalesTramite = plantilla?.fundamento_legal ?? [];
  const fundamentosLegalesMonto = plantilla?.fundamento_legal_monto ?? [];
  const fundamentosLegalesVigencia = plantilla?.tipo_de_resolucion_plantilla
    ?.map((tr) => tr?.fundamento_legal).flat().filter(Boolean) ?? [];
  const fundamentosLegalesPlazoPrevencion = plantilla?.plazo_prevencion
    .map((p) => p.fundamento_legal).flat().filter(Boolean) ?? [];
  const fundamentosLegalesPlazoMaximo = plantilla?.plazo_maximo
    ?.map((r) => r?.fundamento_legal).flat().filter(Boolean) ?? [];
  const fundamentosLegalesFormatoRequerido = plantilla?.formato_requerido
    ?.map((r) => r?.fundamento_legal).flat().filter(Boolean) ?? [];
  const fundamentosLegalesRequisitosGenerales = (plantilla?.requisitos_generales
    ?.map((rg) => rg.fundamento_legal).flat().filter(Boolean) ?? [])
    .concat(plantilla?.casos_de_los_requisitos?.map((c) => c.requisitos)
      .flat().map((r) => r.fundamento_legal)?.flat()
      .filter(Boolean) ?? []);
  const fundamentosLegalesCasosDePresentacion = plantilla?.canal_de_presentacion_plantilla
    ?.flat()?.map((r) => r.fundamento_legal)?.flat().filter(Boolean) ?? [];

  if (!fundamentosLegalesTramite?.length
    && !fundamentosLegalesMonto?.length
    && !fundamentosLegalesVigencia?.length
    && !fundamentosLegalesPlazoPrevencion?.length
    && !fundamentosLegalesPlazoMaximo?.length
    && !fundamentosLegalesFormatoRequerido?.length
    && !fundamentosLegalesRequisitosGenerales?.length
    && !fundamentosLegalesCasosDePresentacion?.length) {
    return (
      <Empty description="No aplica" />
    );
  }

  return (
    <>
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesTramite}
        title="Fundamentos legales del trámite"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesMonto}
        title="Fundamentos legales del monto"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesVigencia}
        title="Fundamentos legales de la vigencia de resolución"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesPlazoPrevencion}
        title="Fundamentos legales del plazo de prevención"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesPlazoMaximo}
        title="Fundamentos legales del plazo máximo"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesFormatoRequerido}
        title="Fundamentos legales de formatos requeridos"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesRequisitosGenerales}
        title="Fundamentos legales de los requisitos generales"
      />
      <FundamentosLegalesItems
        fundamentosLegales={fundamentosLegalesCasosDePresentacion}
        title="Fundamentos legales de los canales de presentación"
      />
    </>
  );
};

const fundamentoLegalShape = {
  id: PropTypes.number,
  denominacion: PropTypes.string,
  articulo: PropTypes.string,
  nombre_de_ordenamiento: PropTypes.shape({
    descripcion: PropTypes.string,
    hipervinculo: PropTypes.string,
  }),
};

FundamentosLegalesTab.propTypes = {
  plantilla: PropTypes.shape({
    plazo_maximo: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    fundamento_legal_monto: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    fundamento_legal: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    tipo_de_resolucion_plantilla: PropTypes.arrayOf(PropTypes.shape({
      fundamento_legal: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    })),
    formato_requerido: PropTypes.arrayOf(PropTypes.shape({
      fundamento_legal: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    })),
    plazo_prevencion: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    requisitos_generales: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
    casos_de_los_requisitos: PropTypes.arrayOf(PropTypes.shape({
      requisitos: PropTypes.arrayOf(PropTypes.shape({
        fundamento_legal: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
      })),
    })),
    canal_de_presentacion_plantilla: PropTypes.arrayOf(PropTypes.shape({
      requisitos: PropTypes.arrayOf(PropTypes.shape({
        fundamento_legal: PropTypes.arrayOf(PropTypes.shape(fundamentoLegalShape)),
      })),
    })),
  }).isRequired,
};

export default FundamentosLegalesTab;
